import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Expression, RuleExpression } from 'types/expression'

type ExpressionModalData = {
    id?: string;
    name: string;
    description: string;
    expression: Expression;
    isEdit: boolean;
}

export const initialExpressionModalData: ExpressionModalData = {
    name: '',
    description: '',
    expression: {
        "id": "",
        "type": "logical",
        "op": "AND",
        "children": []
    },
    isEdit: false
};

type InitialExpressionState = {
    currentExpression: RuleExpression | null;
    showExpressionModal: boolean;
    expressionModalData: ExpressionModalData;
}

const initialState: InitialExpressionState = {
    currentExpression: null,
    showExpressionModal: false,
    expressionModalData: initialExpressionModalData
}

export const expressionSlice = createSlice({
    name: "expression",
    initialState,
    reducers: {
        setCurrentExpression: (state, action: PayloadAction<RuleExpression | null>) => {
            state.currentExpression = action.payload
        },
        setShowExpressionModal: (state, action: PayloadAction<boolean>) => {
            state.showExpressionModal = action.payload
        },
        setExpressionModalData: (state, action: PayloadAction<ExpressionModalData>) => {
            state.expressionModalData = action.payload
        }
    }
})

export const {
    setCurrentExpression, setExpressionModalData, setShowExpressionModal
} = expressionSlice.actions

export default expressionSlice.reducer